var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.003,
    height: 22.001,
    viewBox: "0 0 22.003 22.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-1364.561-446.3h1.394c.249.031.5.058.747.1a10.285,10.285,0,0,1,6.81,3.935,10.2,10.2,0,0,1,2.033,8.539,9.887,9.887,0,0,1-2.655,5.127,10.253,10.253,0,0,1-9.766,3.078,10.489,10.489,0,0,1-8.2-8.406c-.069-.388-.112-.781-.167-1.172V-436.5c.031-.249.059-.5.095-.747a10.333,10.333,0,0,1,2.5-5.459,10.336,10.336,0,0,1,6.317-3.474C-1365.153-446.23-1364.856-446.265-1364.561-446.3Zm-2.356,11.07a4.507,4.507,0,0,1-1.493-3.423,4.42,4.42,0,0,1,1.573-3.384,4.554,4.554,0,0,1,6.133.159,4.586,4.586,0,0,1-.09,6.654,8.512,8.512,0,0,1,4.883,5.094A9.712,9.712,0,0,0-1357-442.777a9.724,9.724,0,0,0-13.7-.029,9.712,9.712,0,0,0-1.117,12.671A8.523,8.523,0,0,1-1366.917-435.235Zm3.206,9.237c.358-.034.879-.053,1.39-.138a9.708,9.708,0,0,0,5.784-3.179.241.241,0,0,0,.055-.271,7.647,7.647,0,0,0-4.829-5.065.467.467,0,0,0-.338.027,4.564,4.564,0,0,1-4.433,0,.442.442,0,0,0-.318-.029,7.641,7.641,0,0,0-4.845,5.074.24.24,0,0,0,.06.27A9.893,9.893,0,0,0-1363.711-426Zm-.161-8.779a3.822,3.822,0,0,0,3.852-3.828,3.831,3.831,0,0,0-3.824-3.844,3.842,3.842,0,0,0-3.864,3.826A3.825,3.825,0,0,0-1363.873-434.777Z",
    transform: "translate(1374.862 446.805)",
    fill: "#2f6bc1",
    stroke: "#2f6bc1",
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/user-icon.5c022364c43c416b1fc5e57d3cb0eb18.svg";
export { ForwardRef as ReactComponent };